import styled from "styled-components";
import { Input } from "antd";

export const StyledInput = styled(Input)`
  height: 36px;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  input {
    font-family: "Open Sans", sans-serif;
  }

  &:hover,
  &:focus,
  &.ant-input-affix-wrapper-focused {
    border-color: #11a7d9;
  }

  &.ant-input-affix-wrapper-disabled,
  &.ant-input-disabled,
  &[disabled] {
    background: #f5f5f5;
    color: rgba(0, 0, 0, 0.45);
    border-color: #e4e4e7;

    input {
      color: rgba(0, 0, 0, 0.45);
      background: transparent;
    }
  }

  .ant-input-prefix {
    margin-right: 8px;
  }
`;
